import { Crumb, Breadcrumb } from './../domain/breadcrum.entity';

const INITIAL_STATE: BreadcrumbState = {
  crumbs: [],
  subtitle: null,
  title: null,
  cssIcon: null,
};
const BREADCRUMB = 'BREADCRUMB';

export const BreadcrumbActions = {
  SET_CRUMBS: `${BREADCRUMB}.SET_CRUMBS`,
};

export function breadcrumbReducer(state: BreadcrumbState = INITIAL_STATE, action: any) {
  switch (action.type) {
    case BreadcrumbActions.SET_CRUMBS:
      if (action.payload.crumbs.length > 0) {
        state.crumbs = <Crumb[]>action.payload.crumbs;
        const lastCrumb = <Crumb>action.payload.crumbs[action.payload.crumbs.length - 1];
        state.title = lastCrumb.label;
        state.subtitle = lastCrumb.subtitle;
        state.cssIcon = action.payload.icon;
      } else {
        return INITIAL_STATE;
      }
      return state;
    default:
      return state;
  }
}

export interface BreadcrumbState extends Breadcrumb {
  crumbs: Crumb[];
  subtitle: string;
  title: string;
  cssIcon: string;
}
